import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-pause-button',
  standalone: true,
  imports: [NgClass],
  templateUrl: './pause-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PauseButtonComponent {
  @Input() isPaused = false;
  @Output() isPausedChange = new EventEmitter<boolean>();

  onButtonClick(): void {
    this.isPaused = !this.isPaused;
    this.isPausedChange.emit(this.isPaused);
  }
}
